import { Box, Container, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import "./StatusScreenMs.css";
import { useAppTheme } from "../../theme/useTheme";
function StatusScreenMs({ status }) {
  const theme = useAppTheme();
  return (
    <Grid className="ms-set-password-container">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        {theme?.assets?.logo && <img src={theme.assets.logo} alt="Worldline" />}
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        {theme?.assets?.rightCircle && <img src={theme.assets.rightCircle} alt="right-circular-gradient" />}
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box>
            <Typography sx={{ fontFamily: "Nunito", whiteSpace: "pre-wrap" }}>{status?.message}</Typography>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default StatusScreenMs;
StatusScreenMs.propTypes = {
  status: PropTypes.object,
};
